/* eslint-disable */
import { disableScrollForInputDrawer, enableScrollForInputDrawer } from '~/js/utils/dom';
const { STOREFRONT_ACCESS_TOKEN } = window;

const HAZARDOUS_GOODS_METAFIELD = /* GraphQL */ `
    query getProductById($id: ID!) {
    product(id: $id) {
      title
      hazardousMaterial: metafield(namespace: "custom", key: "hazardous_materials") {
        value
        type
        key
        namespace
        reference {
          ... on Metaobject {
            id
            type
            fields {
              key
              value
            }
          }
        }
      }
    }
  }
`;

const HAZARDOUS_GOODS_METAFIELDS = /* GraphQL */ `
  query getProductsByIds($query: String!) {
    products(first: 10, query: $query) {
      edges {
        node {
          title
          hazardousMaterial: metafield(namespace: "custom", key: "hazardous_materials") {
            value
            type
            key
            namespace
            reference {
              ... on Metaobject {
                id
                type
                fields {
                  key
                  value
                }
              }
            }
          }
        }
      }
    }
  }`;


const fetchHazardousGoodsMetafield = async (productId) => {
  try {
    const response = await fetch('/api/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query: HAZARDOUS_GOODS_METAFIELD,
        variables: JSON.stringify({
          id: `gid://shopify/Product/${productId}`
        }),
      }),
    });
    
    const { data } = await response.json();
    return data?.product?.hazardousMaterial;
  } catch (error) {
    console.error('Failed to fetch metafield', error);
  }
};

const fetchHazardousGoodsMetafields = async (productTitles) => {
  try {
    const response = await fetch('/api/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query: HAZARDOUS_GOODS_METAFIELDS,
        variables: JSON.stringify({
          query: `${productTitles.join(' OR ')}`,
        }),
      }),
    }).then((res) => res.json());
    const items = await response?.data?.products?.edges;

    return items;

  } catch (error) {
    console.error('Failed to fetch metafields', error);
  }
};

export const rebuyCartHandler = () => ({
  init() {
    this.rebuyCartLimitProductQty();
    this.rebuyItemAdded();
    this.closeQuickBuyModal();
    this.rebuyMobileBodyScrollFix();
  },

  rebuyItemAdded() {
    const setHazardousTieredProps = async (items) => {
      const hazardTieredProducts = await fetchHazardousGoodsMetafields(items.map(({ product_title }) => `title:'${product_title}'`));

      hazardTieredProducts.forEach((hazardProduct, index) => {
        if (!hazardProduct?.node?.hazardousMaterial?.reference) {
          return;
        }

        const {fields} = hazardProduct?.node?.hazardousMaterial?.reference;
        const hazardProps = fields.filter(({ key }) => {
          return key === 'notification_title' || key === 'notification_content';
        }).reduce((acc, { key, value }) => {
          const sanitizedKey = key.split('_').pop();
          acc[`_hazardous_product_${sanitizedKey}`] = value;
          return acc;
        }, {});

        if (!Object.keys(hazardProps).length) {
          return;
        }

        const matchItem = items.find(({ product_title }) => product_title === hazardProduct.node.title);

        window.Rebuy.Cart.changeItem({
          id: matchItem.key,
          properties: {
            ...matchItem.properties,
            ...hazardProps,
          }
        });

      });
    }

    const setHazardousProps = async (event) => {
      const {cart, item} = event.detail;

      if (item?.items?.length) {
        await setHazardousTieredProps(item.items);
        return;
      }

      // If the item is not added by Rebuy, return
      if (item?.properties?._source !== 'Rebuy') {
        return
      }

      const hazardProduct = await fetchHazardousGoodsMetafield(item.product_id)
      const {fields} = hazardProduct?.reference;

      if (!fields || !fields.length) {
        return;
      }

      const hazardProps = fields.filter(({ key }) => {
        return key === 'notification_title' || key === 'notification_content';
      }).reduce((acc, { key, value }) => {
        const sanitizedKey = key.split('_').pop();
        acc[`_hazardous_product_${sanitizedKey}`] = value;
        return acc;
      }, {});

      if (!Object.keys(hazardProps).length) {
        return;
      }

      cart.changeItem({
        id: item.key,
        properties: {
          ...item.properties,
          ...hazardProps,
        }
      });    
    }

    document.addEventListener('rebuy:cart.add', setHazardousProps);
  },

  rebuyCartLimitProductQty() {
    const limitItemQuantities = () => {
      setTimeout(() => {
        const cartItems = Rebuy.SmartCart.items(); // Pull in all the cart items
        // Check and limit the quantity
        cartItems.forEach((item) => {
          if (item.quantity > 10) {
            Rebuy.Cart.setItemQuantity(item, 10);
            alert('Oops! You can add maximum 10 quantity for this item');
          }
        });
      }, 400);
    };

    document.addEventListener('rebuy:cart.change', limitItemQuantities);
  },

  closeQuickBuyModal() {
    const showRebuyCart = () => {
      Alpine.store('quickBuyModal') && Alpine.store('quickBuyModal').hide();
    };

    document.addEventListener('rebuy:smartcart.show', showRebuyCart);
  },

  rebuyMobileBodyScrollFix() {
    const showRebuyCart = () => {
      setTimeout(() => {
        window.isMobile && disableScrollForInputDrawer();
      }, 10); // delay because quickBuyModal hide calls enableScrollForInputDrawer
    };

    const hideRebuyCart = () => {
      window.isMobile && enableScrollForInputDrawer();
    };

    document.addEventListener('rebuy:smartcart.show', showRebuyCart);
    document.addEventListener('rebuy:smartcart.hide', hideRebuyCart);
  },
});

export const rebuyCartState = () => ({
  itemCount: 0,
  retries: 0,
  maxRetries: 10,

  init() {
    document.addEventListener('rebuy:cart.ready', () => this.updateItemCount());
    document.addEventListener('rebuy:cart.change', () => this.updateItemCount());
  },

  updateItemCount() {
    if (Rebuy?.SmartCart) {
      this.itemCount = Rebuy.SmartCart.itemCount();
    } else if (this.retries++ < this.maxRetries) {
      console.warn('updateItemCount - Rebuy.SmartCart is not initialized yet. Retrying...');
      setTimeout(() => this.updateItemCount(), 300); // Retry after 300ms
    } else {
      console.error('updateItemCount - Failed to initialize Rebuy.SmartCart after maximum retries.');
    }
  },
});
